/* PoCichu — koszyk w szufladzie. v8, 04.09.2026

   v3 robił dwie rzeczy: dodawał do koszyka bez przeładowania strony
   i wygładzał animację wysuwania. To zostaje bez zmian.

   Dolożone zachowanie szuflady takie jak w NaOstro:
   A. klik gdziekolwiek poza szufladą ją zamyka — na telefonie i na komputerze
   B. przyciemnienie strony na komputerze (Horizon go tam nie ma, bo w tym
      trybie szuflada jest oknem "niemodalnym" i nie dostaje własnego tła)
   C. "Kontynuuj zakupy" przy pustym koszyku zamyka szufladę zamiast
      przerzucać na /collections/all
   D. napis o zakładaniu konta znika — kont i tak nie używamy
   E. przycisk kasy: "Do kasy", a podsumowanie: "Razem" (v8)
   F. pasek metod płatności zamiast wielkich przycisków Shop Pay / PayPal

   Uwaga do F: BLIK nie może być przyciskiem ekspresowym. Ekspresowe portfele
   to wyłącznie Shop Pay, Apple Pay, Google Pay i PayPal — BLIK pojawia się
   dopiero w kasie. Dlatego pasek jest informacją ("czym zapłacisz"), a nie
   zestawem przycisków. Żeby wrócić do przycisków ekspresowych, ustaw
   POKAZ_EKSPRESOWE na true i usuń regułę .additional-checkout-buttons
   ze snippets/stylesheets.liquid.

   DLACZEGO OBSERWATOR SIEDZI NA <body>:
   Motyw po zmianie koszyka potrafi wymienić całą sekcję cart-drawer-section
   razem z elementem #cart-drawer. Obserwator założony na #cart-drawer zostawał
   wtedy na węźle oderwanym od strony i po cichu przestawał działać. <body> nie
   znika nigdy, a sama poprawka to kilka querySelector — koszt pomijalny.

   DLACZEGO setTimeout, A NIE requestAnimationFrame:
   rAF nie odpala się w karcie, która nie jest widoczna. Przy dławieniu opartym
   na rAF flaga "czeka" zostawała włączona na zawsze i poprawka nigdy nie
   dochodziła do skutku. setTimeout odpala się zawsze.

   Cofnięcie całości = usunięcie jednej linijki <script> ze snippets/stylesheets.liquid. */
(function () {
  'use strict';

  var TAG = '[pocichu-cart]';
  var DRAWER = 'cart-drawer-section';
  var CART_EVENT = 'shopify:cart:lines-update';
  var POKAZ_EKSPRESOWE = false;
  var NAPIS_KASA = 'Do kasy';
  var NAPIS_RAZEM = 'Razem';

  function log() {
    var a = Array.prototype.slice.call(arguments);
    a.unshift(TAG);
    try { console.log.apply(console, a); } catch (err) {}
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function pcForm() {
    return document.getElementById('pc-form');
  }

  function drawerEl() {
    return document.getElementById('cart-drawer');
  }

  function dialogEl() {
    var d = drawerEl();
    return d ? d.querySelector('dialog.theme-drawer__dialog') : null;
  }

  function drawerIsOpen() {
    var d = drawerEl();
    return !!(d && d.hasAttribute('open'));
  }

  function busy(on) {
    ['pc-atc', 'pc-stickybtn'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.toggle('pc-adding', !!on);
      if (on) el.setAttribute('aria-busy', 'true');
      else el.removeAttribute('aria-busy');
    });
  }

  /* Podmiana samej treści szuflady. Zostawia theme-drawer, dialog i cart-drawer-component
     nietknięte — dlatego nie ma ponownej rejestracji komponentu ani przeliczania styli sekcji. */
  function swapInner(html) {
    var live = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!live) { log('brak .cart-drawer__inner na stronie'); return false; }
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.cart-drawer__inner');
    if (!fresh) { log('brak .cart-drawer__inner w odpowiedzi'); return false; }
    live.replaceWith(fresh);
    return true;
  }

  function cartCount() {
    var badge = document.querySelector('#cart-drawer .theme-drawer__badge');
    var n = badge ? parseInt((badge.textContent || '').replace(/\D+/g, ''), 10) : NaN;
    return isNaN(n) ? null : n;
  }

  /* Natywne zdarzenie motywu: odświeża licznik przy ikonce (cart-icon)
     i pozwala szufladzie otworzyć się jej własnym mechanizmem auto-open. */
  function announce(count) {
    var ev;
    try { ev = new CustomEvent(CART_EVENT, { bubbles: true }); }
    catch (err) { return; }
    ev.action = 'add';
    ev.promise = Promise.resolve({
      cart: count === null ? null : { totalQuantity: count },
      detail: { itemCount: count === null ? 0 : count, didError: false }
    });
    document.dispatchEvent(ev);
  }

  function openDrawer() {
    function go() {
      var d = drawerEl();
      if (!d || typeof d.open !== 'function') return false;
      if (d.isOpen) return true;
      d.open();
      return true;
    }
    if (go()) return;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(function () {
        setTimeout(function () {
          if (go()) return;
          var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (trigger) trigger.click();
        }, 0);
      });
    }
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    if (typeof d.close === 'function') { d.close(); return; }
    /* awaryjnie, gdyby komponent jeszcze się nie podniósł */
    var dlg = dialogEl();
    if (dlg) { try { dlg.close(); } catch (err) {} }
    d.removeAttribute('open');
  }

  var pending = false;

  function addToCart(e, source) {
    var f = pcForm();
    if (!f) return;
    if (pending) { if (e) e.preventDefault(); return; }

    var idInput = f.querySelector('#pc-varid') || f.querySelector('[name="id"]');
    var qtyInput = f.querySelector('[name="quantity"]');
    var variantId = idInput && idInput.value;
    if (!variantId) { log('brak wariantu — przepuszczam formularz'); return; }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    pending = true;
    busy(true);
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: Number((qtyInput && qtyInput.value) || 1) }],
        sections: [DRAWER],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (err) { log('odpowiedź nie jest JSON-em', t.slice(0, 160)); }
          return { ok: r.ok, status: r.status, data: j };
        });
      })
      .then(function (res) {
        if (!res.ok || !res.data) throw new Error('HTTP ' + res.status);
        var html = res.data.sections && res.data.sections[DRAWER];
        if (html) swapInner(html);
        poprawSzuflade();
        var n = cartCount();
        announce(n);
        openDrawer();
        zaplanujPoprawke();
        pending = false;
        busy(false);
        var ms = Math.round(((window.performance && performance.now) ? performance.now() : Date.now()) - t0);
        log('gotowe w ' + ms + ' ms', { source: source, w_koszyku: n });
      })
      .catch(function (err) {
        log('AWARYJNIE — wracam do zwykłego formularza. Przyczyna:', err && err.message ? err.message : err);
        pending = false;
        busy(false);
        var f2 = pcForm();
        if (f2) HTMLFormElement.prototype.submit.call(f2);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('#pc-atc, #pc-stickybtn');
    if (b) addToCart(e, 'klik:' + b.id);
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'pc-form') addToCart(e, 'submit');
  }, true);

  /* ================================================================
     A. ZAMYKANIE KLIKNIĘCIEM POZA SZUFLADĄ

     Horizon domyślnie tego nie robi na komputerze i to nie jest błąd —
     powyżej 990 px szuflada jest oknem "niemodalnym" (panel.show()), więc
     nie ma tła, w które można kliknąć, a jedyny uchwyt zamykający siedzi
     na samym oknie. Poniżej 990 px tło jest, ale liczymy tak samo, żeby
     zachowanie było jedno na obu szerokościach.

     Liczymy po współrzędnych, a nie po tym, w co trafił klik: przy oknie
     modalnym kliknięcie w tło ma jako cel sam element <dialog>, więc
     sprawdzanie "czy cel jest wewnątrz" dałoby fałszywe trafienie.
     ================================================================ */

  function isDrawerTrigger(el) {
    while (el && el.nodeType === 1) {
      if (el.getAttribute) {
        if (el.getAttribute('aria-controls') === 'cart-drawer') return true;
        var oc = el.getAttribute('on:click');
        if (oc && oc.indexOf('#cart-drawer') === 0) return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  document.addEventListener('pointerdown', function (e) {
    if (!drawerIsOpen()) return;
    var dlg = dialogEl();
    if (!dlg) return;

    /* ikonka koszyka sama się przełącza — nie zamykamy jej spod palca */
    if (isDrawerTrigger(e.target)) return;
    /* klik w treść szuflady zostawiamy w spokoju (cel === dialog to tło) */
    if (e.target !== dlg && dlg.contains(e.target)) return;
    /* otwarte okno w środku szuflady (np. podgląd rat) ma pierwszeństwo */
    if (dlg.querySelector('dialog[open]')) return;

    var r = dlg.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return;

    closeDrawer();
  }, true);

  /* ================================================================
     B. PRZYCIEMNIENIE STRONY NA KOMPUTERZE
     Na telefonie robi to natywne ::backdrop okna modalnego.
     ================================================================ */
  var scrim = document.createElement('div');
  scrim.className = 'pc-scrim';
  scrim.setAttribute('aria-hidden', 'true');
  function mountScrim() {
    if (document.body && !scrim.parentNode) document.body.appendChild(scrim);
  }
  if (document.body) mountScrim();
  else document.addEventListener('DOMContentLoaded', mountScrim);

  scrim.addEventListener('click', closeDrawer);
  document.addEventListener('theme-drawer:open', function (e) {
    if (e.target && e.target.id === 'cart-drawer') scrim.classList.add('on');
  });
  document.addEventListener('theme-drawer:close', function (e) {
    if (e.target && e.target.id === 'cart-drawer') scrim.classList.remove('on');
  });

  /* ================================================================
     C. "Kontynuuj zakupy" — zamknij szufladę, nie przeń na inną stronę
     ================================================================ */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('#cart-drawer .cart-items__empty-button')) return;
    e.preventDefault();
    closeDrawer();
  }, true);

  /* ================================================================
     E + F. NAPISY I PASEK METOD PŁATNOŚCI
     ================================================================ */

  var IKONY = [
    { n: 'BLIK', h: '<span class="pc-pay__blik">blik</span>' },
    { n: 'Apple Pay', h:
        '<svg viewBox="0 0 14 17" width="11" height="13" aria-hidden="true" fill="#000">' +
        '<path d="M11.18 8.98c-.02-1.83 1.49-2.71 1.56-2.75-.85-1.24-2.17-1.41-2.64-1.43-1.12-.11-2.19.66-2.76.66' +
        '-.57 0-1.45-.64-2.38-.63-1.22.02-2.35.71-2.98 1.8-1.27 2.2-.32 5.46.91 7.25.6.88 1.32 1.86 2.26 1.82' +
        '.91-.04 1.25-.59 2.35-.59 1.09 0 1.41.59 2.37.57.98-.02 1.6-.89 2.2-1.77.69-1.01.98-1.99 1-2.04' +
        '-.02-.01-1.91-.73-1.93-2.89zM9.53 3.55c.5-.61.84-1.45.75-2.29-.72.03-1.6.48-2.12 1.09' +
        '-.46.54-.87 1.4-.76 2.22.81.06 1.63-.41 2.13-1.02z"/></svg><span>Pay</span>' },
    { n: 'Google Pay', h:
        '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">' +
        '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>' +
        '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>' +
        '<path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>' +
        '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>' +
        '</svg><span>Pay</span>' },
    { n: 'Visa', h: '<span class="pc-pay__visa">VISA</span>' },
    { n: 'Mastercard', h:
        '<svg viewBox="0 0 32 20" width="22" height="14" aria-hidden="true">' +
        '<circle cx="12" cy="10" r="8.4" fill="#EB001B"/>' +
        '<circle cx="20" cy="10" r="8.4" fill="#F79E1B" fill-opacity=".85"/></svg>' }
  ];

  function budujPasek() {
    var wrap = document.createElement('div');
    wrap.className = 'pc-pay';
    wrap.setAttribute('aria-label', 'Akceptowane metody płatności');
    var html = '';
    for (var i = 0; i < IKONY.length; i++) {
      html += '<span class="pc-pay__i" title="' + IKONY[i].n + '">' + IKONY[i].h + '</span>';
    }
    wrap.innerHTML = html;
    return wrap;
  }

  function poprawSzuflade() {
    var d = drawerEl();
    if (!d) return;

    var span = d.querySelector('.cart__checkout-button .button-text');
    if (span && span.textContent.trim() !== NAPIS_KASA) span.textContent = NAPIS_KASA;

    /* "Przewidywana suma" -> "Razem", tak jak w NaOstro */
    var suma = d.querySelector('.cart-totals__total-label');
    if (suma && suma.textContent.trim() !== NAPIS_RAZEM) suma.textContent = NAPIS_RAZEM;

    var ctas = d.querySelector('.cart__ctas');
    if (ctas && !ctas.querySelector('.pc-pay') && !POKAZ_EKSPRESOWE) {
      ctas.appendChild(budujPasek());
    }
  }

  var czeka = false;
  function zaplanujPoprawke() {
    if (czeka) return;
    czeka = true;
    setTimeout(function () { czeka = false; poprawSzuflade(); }, 0);
  }

  function startPilnowania() {
    if (!document.body) return;
    new MutationObserver(zaplanujPoprawke).observe(document.body, { childList: true, subtree: true });
    poprawSzuflade();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPilnowania);
  } else {
    startPilnowania();
  }
  window.addEventListener('load', zaplanujPoprawke);
  document.addEventListener('theme-drawer:open', zaplanujPoprawke);
  document.addEventListener(CART_EVENT, zaplanujPoprawke);
  document.addEventListener('shopify:section:load', zaplanujPoprawke);

  /* ---- PŁYNNOŚĆ ----
     Horizon animuje szufladę własnością `right`, więc przeglądarka przelicza layout
     w każdej klatce — przy 70 KB markupu koszyka to właśnie daje szarpanie.
     Przestawiam na `transform: translateX()`, który leci na GPU.
     Wyłączam też "ściskanie" strony na desktopie — animowanie marginesu całej strony
     to drugie źródło szarpania, a szuflada ma nachodzić na treść jak w NaOstro. */
  var css = document.createElement('style');
  css.textContent = [
    '@keyframes pc-drawer-in{from{transform:translateX(100%)}to{transform:translateX(0)}}',
    '@keyframes pc-drawer-out{from{transform:translateX(0)}to{transform:translateX(100%)}}',
    '#cart-drawer .theme-drawer__dialog{right:0!important;transform:translateX(100%);' +
      'will-change:transform;backface-visibility:hidden}',
    '#cart-drawer .theme-drawer__dialog[open]{transform:translateX(0)}',
    '#cart-drawer .theme-drawer__dialog.theme-drawer__dialog--opening{' +
      'animation:pc-drawer-in .34s cubic-bezier(.32,.72,0,1)!important}',
    '#cart-drawer .theme-drawer__dialog.theme-drawer__dialog--closing{' +
      'animation:pc-drawer-out .28s cubic-bezier(.32,.72,0,1) forwards!important}',
    '#cart-drawer .theme-drawer__dialog.theme-drawer__dialog-instant{animation:none!important}',
    '.page-wrapper.page-wrapper--drawer-open{margin-right:0!important;transition:none!important}',
    '.pc-adding{opacity:.72;pointer-events:none;transition:opacity .12s ease}',
    '#pc-atc,#pc-stickybtn{transition:opacity .12s ease,transform .08s ease}',
    '#pc-atc:active,#pc-stickybtn:active{transform:scale(.985)}',
    '@media (prefers-reduced-motion:reduce){' +
      '#cart-drawer .theme-drawer__dialog.theme-drawer__dialog--opening,' +
      '#cart-drawer .theme-drawer__dialog.theme-drawer__dialog--closing{animation-duration:.01s!important}}'
  ].join('\n');
  document.head.appendChild(css);

  log('v8 gotowy — czysty dół szuflady: Razem + Do kasy + metody płatności');
})();
